import { render, staticRenderFns } from "./deliveryDialog.vue?vue&type=template&id=37d30ceb&scoped=true&"
import script from "./deliveryDialog.vue?vue&type=script&lang=js&"
export * from "./deliveryDialog.vue?vue&type=script&lang=js&"
import style0 from "./deliveryDialog.vue?vue&type=style&index=0&id=37d30ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d30ceb",
  null
  
)

export default component.exports